import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';

@Component({
  selector: 'app-customer-leads',
  templateUrl: './customer-leads.component.html',
  styleUrls: ['./customer-leads.component.css']
})
export class CustomerLeadsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CustomerLeadsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private date_format: getdateformatService) { }

  ngOnInit() {
  }

  closeDialog(){
    this.dialogRef.close();
  }
  getDateFormat(type?){
    return this.date_format.getDateFormat(type);
  }
}
